"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
function CustomerFromJSON(json) {
    return CustomerFromJSONTyped(json, false);
}
exports.CustomerFromJSON = CustomerFromJSON;
function CustomerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'full_name': json['full_name'],
        'phone': json['phone'],
        'has_password': json['has_password'],
        'dob': (json['dob'] === null ? null : new Date(json['dob'])),
        'brand_id': json['brand_id'],
        'site_id': json['site_id'],
        'stripe_id': json['stripe_id'],
        'express_stripe_id': json['express_stripe_id'],
        'email': json['email'],
        'labels': (json['labels'].map(_1.CustomerLabelFromJSON)),
        'preferred_locale': json['preferred_locale'],
        'locked_at': (json['locked_at'] === null ? null : new Date(json['locked_at'])),
        'created_at': (new Date(json['created_at'])),
        'updated_at': (new Date(json['updated_at'])),
        'deleted_at': (json['deleted_at'] === null ? null : new Date(json['deleted_at'])),
        'last_active_at': (json['last_active_at'] === null ? null : new Date(json['last_active_at'])),
        'email_verified_at': (json['email_verified_at'] === null ? null : new Date(json['email_verified_at'])),
        'last_check_in': _1.LastCheckInSummaryFromJSON(json['last_check_in']),
        'avatar_id': json['avatar_id'],
        'avatar': _1.Media3FromJSON(json['avatar']),
        'external_ref': json['external_ref'],
    };
}
exports.CustomerFromJSONTyped = CustomerFromJSONTyped;
function CustomerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'full_name': value.full_name,
        'phone': value.phone,
        'has_password': value.has_password,
        'dob': (value.dob === null ? null : value.dob.toISOString().substr(0, 10)),
        'brand_id': value.brand_id,
        'site_id': value.site_id,
        'stripe_id': value.stripe_id,
        'express_stripe_id': value.express_stripe_id,
        'email': value.email,
        'labels': (value.labels.map(_1.CustomerLabelToJSON)),
        'preferred_locale': value.preferred_locale,
        'locked_at': (value.locked_at === null ? null : value.locked_at.toISOString()),
        'created_at': (value.created_at.toISOString()),
        'updated_at': (value.updated_at.toISOString()),
        'deleted_at': (value.deleted_at === null ? null : value.deleted_at.toISOString()),
        'last_active_at': (value.last_active_at === null ? null : value.last_active_at.toISOString()),
        'email_verified_at': (value.email_verified_at === null ? null : value.email_verified_at.toISOString()),
        'last_check_in': _1.LastCheckInSummaryToJSON(value.last_check_in),
        'avatar_id': value.avatar_id,
        'avatar': _1.Media3ToJSON(value.avatar),
        'external_ref': value.external_ref,
    };
}
exports.CustomerToJSON = CustomerToJSON;
